<template>
    <div>
        <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-100">
                <md-card>
                    <md-card-header class="md-card-header-icon md-card-header-blue">
                        <div class="card-icon">
                            <font-awesome-icon class="md-icon" :icon="['fa', 'info']"/>
                        </div>
                        <div class="md-layout text-center pb-1.5">
                            <div v-if="intervention.planning_intervention_prevision_id !== null">
                                <div class="md-layout-item">ID Plan D'intervention</div>
                                <div class="md-layout-item font-bold">{{ intervention.planning_intervention_prevision.planning_intervention_group.planning_intervention_id }}</div>
                            </div>
                            <div>
                                <div class="md-layout-item">ID intervention</div>
                                <div class="md-layout-item font-bold">{{ intervention.id }}</div>
                            </div>
                            <div>
                                <div class="md-layout-item">Type d'intervention</div>
                                <div class="md-layout-item font-bold">{{ intervention.intervention_type.name }}</div>
                            </div>
                            <div>
                                <div class="md-layout-item">Type de prestation</div>
                                <div class="md-layout-item font-bold">{{ intervention.category_id + ' ( ' + intervention.category.name + ' )' }}</div>
                            </div>
                        </div>
                    </md-card-header>
                </md-card>
            </div>
        </div>
        <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-100">
                <md-card>
                    <md-card-header class="md-card-header-icon md-card-header-blue">
                        <div class="card-icon">
                            <font-awesome-icon class="md-icon" :icon="['fa', 'cog']"/>
                        </div>
                        <h4 class="title">Dispositifs</h4>
                    </md-card-header>
                    <md-card-content>
                        <div v-for="(deviceReport, index) in deviceReports" :key="index">
                            <div class="text-center">MODELE #{{ index }}</div>
                            <div class="text-center">Types associées: {{
                                    deviceReport[0].current_device_type.device_report_type.device_types.map((type) => {
                                        return type.id
                                    }).join(', ')
                                }}
                            </div>
                            <table-report1 v-if="index === '1'" :device-report="deviceReport"
                                           @submit-reports="submitReports($event, 1)"
                                           @delete-reports="deleteReports($event, 1)"></table-report1>
                            <table-report2 v-else-if="index === '2'" :device-report="deviceReport"
                                           @submit-reports="submitReports($event, 2)"
                                           @delete-reports="deleteReports($event, 2)"></table-report2>
                            <table-report3 v-else-if="index === '3'" :device-report="deviceReport"
                                           @submit-reports="submitReports($event, 3)"
                                           @delete-reports="deleteReports($event, 3)"></table-report3>
                            <table-report4 v-else-if="index === '4'" :device-report="deviceReport"
                                           @submit-reports="submitReports($event, 4)"
                                           @delete-reports="deleteReports($event, 4)"></table-report4>
                            <table-report5 v-else-if="index === '5'" :device-report="deviceReport"
                                           @submit-reports="submitReports($event, 5)"
                                           @delete-reports="deleteReports($event, 5)"></table-report5>
                            <table-report6 v-else-if="index === '6'" :device-report="deviceReport"
                                           @submit-reports="submitReports($event, 6)"
                                           @delete-reports="deleteReports($event, 6)"></table-report6>
                            <table-report7 v-else-if="index === '7'" :device-report="deviceReport"
                                           @submit-reports="submitReports($event, 7)"
                                           @delete-reports="deleteReports($event, 7)"></table-report7>
                            <table-report8 v-else-if="index === '8'" :device-report="deviceReport"
                                           @submit-reports="submitReports($event, 8)"
                                           @delete-reports="deleteReports($event, 8)"></table-report8>
                        </div>
                    </md-card-content>
                </md-card>
            </div>
        </div>
    </div>
</template>

<script>
import tableReport1 from './deviceReports/TableReportModel1'
import tableReport2 from './deviceReports/TableReportModel2'
import tableReport3 from './deviceReports/TableReportModel3'
import tableReport4 from './deviceReports/TableReportModel4'
import tableReport5 from './deviceReports/TableReportModel5'
import tableReport6 from './deviceReports/TableReportModel6'
import tableReport7 from './deviceReports/TableReportModel7'
import tableReport8 from './deviceReports/TableReportModel8'

export default {
    name: "DevicesReport",
    components: {
        tableReport1,
        tableReport2,
        tableReport3,
        tableReport4,
        tableReport5,
        tableReport6,
        tableReport7,
        tableReport8
    },
    data() {
        return {
            deviceReports: [],
            waiting: false
        }
    },
    props: {
        intervention: {
            type: Object
        }
    },
    methods: {
        async getDevices() {
            const {data} = await this.$store.dispatch('interventions/getInterventionDevicesDetails', {
                id: this.$route.params.id
            })
            this.deviceReports = data
        },
        async submitReports(e, reportId) {
            if (!this.waiting) {
                this.waiting = true
                try {
                    await this.$store.dispatch('interventions/addInterventionDevicesReports', {
                        interventionId: this.$route.params.id,
                        reports: e,
                        deviceReportTypeId: reportId,
                    }).then((data) => {
                        this.deviceReports[reportId].forEach((device) => {
                            if (data.data[device.id]) {
                                device.report = data.data[device.id]
                            }
                        })
                    })

                    await this.$store.dispatch('alerts/success', 'Fiches de suivies créées')
                } catch (e) {}
                this.waiting = false
            }
        },
        async deleteReports(e, reportId) {
            if (!this.waiting) {
                this.waiting = true
                try {
                    await this.$store.dispatch('interventions/deleteInterventionDevicesReports', {
                        interventionId: this.$route.params.id,
                        reports: e,
                    }).then((data) => {
                        this.deviceReports[reportId].forEach((device) => {
                            if (data.data[device.id]) {
                                device.report_values = data.data[device.id]
                                if (device.report_values.report) {
                                    device.report = device.report_values.report
                                    delete device.report_values.report
                                } else {
                                    delete device.report
                                    delete device.report_values.old_type
                                }
                            }
                        })
                    })

                    await this.$store.dispatch('alerts/success', 'Fiches de suivies supprimées')
                    this.toggleAllCheck(reportId)
                } catch (e) {}
                this.waiting = false
            }
        },
        toggleAllCheck(id) {
            this.deviceReports[id].forEach((device) => {
                device.report_values.isChecked = false
            })
        }
    },
    mounted() {
        this.getDevices()
    }
}
</script>

<style lang="scss" scoped>
::v-deep {

    .table-w-300 {
        max-width: 300px;
        min-width: 300px;
    }

    .table-w-250 {
        max-width: 250px;
        min-width: 250px;
    }

    .table-w-220 {
        max-width: 220px;
        min-width: 220px;
    }

    .table-w-200 {
        max-width: 200px;
        min-width: 200px;
    }

    .table-w-170 {
        max-width: 170px;
        min-width: 170px;
    }

    .table-w-150 {
        max-width: 150px;
        min-width: 150px;
    }

    .table-w-120 {
        max-width: 120px;
        min-width: 120px;
    }

    .table-w-100 {
        max-width: 100px;
        min-width: 100px;
    }

    .table-w-90 {
        max-width: 90px;
        min-width: 90px;
    }

    .table-w-70 {
        max-width: 70px;
        min-width: 70px;
    }

    .table-w-60 {
        max-width: 60px;
        min-width: 60px;
    }

    .table-w-50 {
        max-width: 50px;
        min-width: 50px;
    }

    .table-w-40 {
        max-width: 40px;
        min-width: 40px;
    }

    .device_type_icon {
        width: 15px;
        margin-right: 0.5rem;
    }

    td, th {
        padding-left: 5px;
    }

    .md-field.md-disabled {
        &::after {
            border-bottom: 1px solid #d2d2d2 !important;
            opacity: 1 !important;
        }

        pointer-events: none !important;
        opacity: .6 !important;
    }
}
</style>
